import { Card, Row, Typography } from "antd";

export const StaticCard: React.FC<{
  title: string;
  value: number;
  className: string;
  icon: React.ReactNode | null;
}> = ({ title, value, className, icon }) => {
  return (
    <Card bordered={false} className="criclebox ">
      <div className="number">
        <Row align="middle" justify="space-between" gutter={[24, 0]}>
          <div>
            <span>{title.toLocaleUpperCase()}</span>
            <Typography.Title className={className} level={3}>
              {value}
            </Typography.Title>
          </div>
          <div style={{ paddingLeft: 0 }}>
            <div className="icon-box">{icon}</div>
          </div>
        </Row>
      </div>
    </Card>
  );
};
